import { VoucherState } from '@src/domains/vouchers';
import type { DefaultMessagesKeys } from '@src/i18n/useTranslate';

export const VOUCHER_STATE_LABEL_KEYS: Record<VoucherState, DefaultMessagesKeys> = {
  [VoucherState.Open]: 'checkout_vouchers_modal_status_open',
  [VoucherState.Consumed]: 'checkout_vouchers_modal_status_consumed',
  [VoucherState.Revoked]: 'checkout_vouchers_modal_status_revoked',
  [VoucherState.Pending]: 'checkout_vouchers_modal_status_pending',
};
